// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"27":"9c93c0a9","289":"8345095f","524":"739e5158","653":"b8e3b633","681":"00d186f5","787":"0081be7c","815":"780a4028"}[chunkId] + ".chunk.js";
};